import React from 'react';
import { Image } from '@components/common';
import utils from '@utils';
import classNames from 'classnames';

const reportsColumn = (type, payNowFunction) => {
	const columnArray = [
		{
			property : 'details',
			header   : {
				label : `${type} Name`,
			},
			cell : {
				formatters : [
					(value, {
						rowData : {
							LocationName, Name, ProfileImage, DepartmentName,
						},
					}) => (
						<Choose>
							<When condition={type === 'Location'}>
								<p className="margin-bottom-0">
									<span className="font-regular display-block color-gray-oxford font-size-14">{ LocationName }</span>
								</p>
							</When>
							<Otherwise>
								<div className="flex mobile-max-width">
									<Image
										className="height-30 width-30 border-radius-15 margin-right-10 img-cover"
										src={ProfileImage || ''}
										fallbackSrc="avatar"
									/>
									<p className="margin-bottom-0">
										<span className="font-regular display-block color-gray-oxford font-size-14">{ Name }</span>
										<span className="font-regular display-block color-gray-bayoux font-size-12">{ LocationName || DepartmentName }</span>
									</p>
								</div>
							</Otherwise>
						</Choose>
					),
				],
			},
		},
		{
			property : 'jobsWorked',
			header   : {
				label : 'Jobs Worked',
			},
			cell : {
				formatters : [
					(value, { rowData : { JobsWorked } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ JobsWorked }</span>
					),
				],
			},
		},
		{
			property : 'pendingPayments',
			header   : {
				label : '# Pending Payments',
			},
			cell : {
				formatters : [
					(value, { rowData : { PendingPayments } }) => (
						<div className="flex flex-direction-column padding-left-20">
							<span className="font-regular color-gray-oxford font-size-14 padding-left-10">{ PendingPayments }</span>
							<If condition={PendingPayments}>
								<span
									className="font-light font-size-10 text-primary cursor-pointer"
									onClick={() => payNowFunction()}
									onKeyPress={null}
									role="button"
									tabIndex={0}
									alt="pay now button"
								>
									Pay Now
								</span>
							</If>
						</div>
					),
				],
			},
		},
		{
			property : 'invoicesPaid',
			header   : {
				label : '# Invoices Paid',
			},
			cell : {
				formatters : [
					(value, { rowData : { TotalNumberOfInvoicesPaid } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ TotalNumberOfInvoicesPaid }</span>
					),
				],
			},
		},
		{
			property : 'total',
			header   : {
				label : 'Total Paid',
			},
			cell : {
				formatters : [
					(value, { rowData : { TotalPaid } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ utils.currencyFormatter(TotalPaid || 0) }</span>
					),
				],
			},
		},
	];

	if (type === 'clientOverview') {
		columnArray.splice(1, 0, {
			property : 'address',
			header   : {
				label : 'Location Address',
			},
			cell : {
				formatters : [
					(value, { rowData : { LocationDetails } }) => (
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-gray-oxford font-size-14">{ LocationDetails }</span>
						</p>
					),
				],
			},
		});
	}

	return columnArray;
};

const clientOverviewColumns = (type) => {
	const columns = [
		{
			property : 'empty',
			header   : {
				label : '',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'jobCount',
			header   : {
				label : 'Total Job Count',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'totalHours',
			header   : {
				label : 'Total Hours',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'locationsCount',
			header   : {
				label : '# of Locations',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'officersAssignedCount',
			header   : {
				label : '# of Officers Assigned',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
	];

	if (type === 'clientOverview') {
		columns.splice(1, 0, {
			property : 'projects',
			header   : {
				label : 'Projects',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		});
	}

	return columns;
};

const projectsColumns = [
	{
		property : 'Project',
		header   : {
			label : '',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'SupervisorName',
		header   : {
			label : 'Client Supervisor',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'HoursScheduled',
		header   : {
			label : 'Total Hours Scheduled',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'HoursWorked',
		header   : {
			label : 'Total Hours Worked',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'TotalJobLocations',
		header   : {
			label : '# of Locations',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'TotalOfficersAssigned',
		header   : {
			label : '# of Officers Assigned',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'TotalOfficersWorked',
		header   : {
			label : '# of Officers Worked',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'ProjectStatus',
		header   : {
			label : 'Status',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
];

const officersColumns = [
	{
		property : 'OfficerName',
		header   : {
			label : 'Officer Name',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'JobsScheduled',
		header   : {
			label : 'Jobs Scheduled',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'JobsWorked',
		header   : {
			label : 'Jobs Worked',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'HoursScheduled',
		header   : {
			label : 'Hours Scheduled',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
	{
		property : 'HoursWorked',
		header   : {
			label : 'Hours Worked',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular color-gray-oxford font-size-14">{ value }</span>
				),
			],
		},
	},
];

const reportsJobColumn = (reportType = 'invoiceHistory', invoiceIdClicked, transactionIdClicked, timeZoneId) => {
	const columnArray = [
		{
			property : 'invoiceId',
			header   : {
				label : 'Invoice ID',
			},
			cell : {
				formatters : [
					(value, { rowData }) => (
						<div className="text-center">
							<span
								className="font-regular text-primary font-size-14 cursor-pointer"
								onClick={() => invoiceIdClicked(rowData)}
								onKeyPress={null}
								role="link"
								tabIndex={0}
							>
								{ rowData.InvoiceId }
							</span>
						</div>
					),
				],
			},
		},
		{
			property : 'dateTime',
			header   : {
				label : 'Date/Time',
			},
			cell : {
				formatters : [
					(value, { rowData : { JobDate, ClockIn, ClockOut } }) => (
						<p className="margin-bottom-0 margin-left--10">
							<span className="font-regular display-block color-gray-oxford font-size-14">
								{ utils.parseUTCDateToTimeZone(JobDate, timeZoneId).format('M/D/YYYY') }
							</span>
							<Choose>
								<When condition={ClockIn && ClockOut}>
									<span className="font-regular display-block color-gray-bayoux font-size-12">
										{ utils.parseUTCDateToTimeZone(ClockIn, timeZoneId).format('h:mm A') }
										{' '}
										-
										{' '}
										{ utils.parseUTCDateToTimeZone(ClockOut, timeZoneId).format('h:mm A') }
									</span>
								</When>
								<Otherwise>
									<span className="font-regular display-block color-gray-bayoux font-size-12">No Clock In</span>
								</Otherwise>
							</Choose>
						</p>
					),
				],
			},
		},
		{
			property : 'address',
			header   : {
				label : 'Location',
			},
			cell : {
				formatters : [
					(value, { rowData : { Location, LocationDetails } }) => (
						<p className="margin-bottom-0 margin-left--10">
							<span className="font-regular display-block color-gray-oxford font-size-14">{ Location }</span>
							<span className="font-regular display-block color-gray-oxford font-size-14">{ LocationDetails }</span>
						</p>
					),
				],
			},
		},
		{
			property : 'officer',
			header   : {
				label : 'Officer',
			},
			cell : {
				formatters : [
					(value, { rowData : { OfficerName, OfficerLocation } }) => (
						<p className="margin-bottom-0 margin-left--10">
							<span className="font-regular display-block color-gray-oxford font-size-14">{ OfficerName }</span>
							<span className="font-regular display-block color-gray-bayoux font-size-12">{ OfficerLocation }</span>
						</p>
					),
				],
			},
		},
		{
			property : 'transactionId',
			header   : {
				label : 'Transaction ID',
			},
			cell : {
				formatters : [
					(value, { rowData }) => (
						<div className="text-center">
							<span
								onClick={() => transactionIdClicked(rowData)}
								className="font-regular text-primary font-size-14 cursor-pointer"
								onKeyPress={null}
								role="link"
								tabIndex={-1}
							>
								{ rowData.TransactionId }
							</span>
						</div>
					),
				],
			},
		},
		{
			property : 'amount',
			header   : {
				label : 'Amount',
			},
			cell : {
				formatters : [
					(value, { rowData : { Amount } }) => (
						<span className="margin-left--10 font-regular color-gray-oxford font-size-14">{ utils.currencyFormatter(Amount || 0) }</span>
					),
				],
			},
		},
	];

	if (reportType === 'invoiceHistory') {
		columnArray.splice(4, 0, {
			property : 'status',
			header   : {
				label : 'Status',
			},
			cell : {
				formatters : [
					(value, { rowData : { statusObj : { label, value : data } } }) => (
						<span className={classNames('margin-left--10 new-label', `label-${label}`)}>{ data }</span>
					),
				],
			},
		});
	}

	return columnArray;
};

const paymentReportsColumn = (type) => {
	const columnArray = [
		{
			property : 'details',
			header   : {
				label : `${type} Name`,
			},
			cell : {
				formatters : [
					(value, { rowData : { Name, ProfileImageUrl, DepartmentName } }) => (
						<div className="flex mobile-max-width">
							<If condition={type !== 'Location'}>
								<Image
									className="height-30 width-30 border-radius-15 margin-right-10 img-cover"
									src={ProfileImageUrl || ''}
									fallbackSrc="avatar"
								/>
							</If>
							<p className="margin-bottom-0">
								<span className="font-regular display-block color-gray-oxford font-size-14">{ Name }</span>
								<span className="font-regular display-block color-gray-bayoux font-size-12">{ DepartmentName || '' }</span>
							</p>
						</div>
					),
				],
			},
		},
		{
			property : 'jobsWorked',
			header   : {
				label : type === 'Coordinator' ? 'Jobs Coordinated' : 'Jobs Worked',
			},
			cell : {
				formatters : [
					(value, { rowData : { WorkedJobs, CoordinatedJobs } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ type === 'Coordinator' ? CoordinatedJobs : WorkedJobs }</span>
					),
				],
			},
		},
		{
			property : 'invoicesPaid',
			header   : {
				label : '# Invoices Paid',
			},
			cell : {
				formatters : [
					(value, { rowData : { PaidInvoices } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ PaidInvoices }</span>
					),
				],
			},
		},
		{
			property : 'total',
			header   : {
				label : 'Total Paid',
			},
			cell : {
				formatters : [
					(value, { rowData : { TotalPaid } }) => (
						<span className="font-regular color-gray-oxford font-size-14">{ utils.currencyFormatter(TotalPaid || 0) }</span>
					),
				],
			},
		},
	];

	if (type === 'Location') {
		columnArray.splice(1, 0, {
			property : 'address',
			header   : {
				label : 'Location Address',
			},
			cell : {
				formatters : [
					(value, { rowData : { LocationAddress } }) => (
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-gray-oxford font-size-14">{ LocationAddress }</span>
						</p>
					),
				],
			},
		});
	}

	return columnArray;
};

const transactionHistoryColumn = (viewDetailsFunction, timeZoneId) => ([
	{
		property : 'dateTime',
		cell     : {
			formatters : [
				(value, { rowData : { TransactionDateUTC } }) => (
					<div className="flex text-center margin-top-15 margin-bottom-15 padding-left-20">
						<Choose>
							<When condition={TransactionDateUTC}>
								<p className="margin-bottom-0">
									<span className="font-regular display-block color-blue-bayoux font-size-14">
										{ utils.parseUTCDateToTimeZone(TransactionDateUTC, timeZoneId).format('ddd') }
									</span>
									<span className="font-regular display-block color-blue-bayoux font-size-14">
										{ utils.parseUTCDateToTimeZone(TransactionDateUTC, timeZoneId).format('MMM DD') }
									</span>
									<span className="font-light display-block color-blue-bayoux font-size-12">
										{ utils.parseUTCDateToTimeZone(TransactionDateUTC, timeZoneId).format('hh:mm A') }
									</span>
								</p>
							</When>
							<Otherwise>
								<p className="margin-bottom-0">
									<span className="font-regular display-block color-blue-bayoux font-size-14">No Date</span>
								</p>
							</Otherwise>
						</Choose>
					</div>
				),
			],
		},
	},
	{
		property : 'details',
		cell     : {
			formatters : [
				(value, { rowData : { Amount, PaymentMethod } }) => (
					<div className="flex padding-left-20">
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-dark font-size-16">{utils.currencyFormatter(Amount)}</span>
							<span className="font-light display-block color-gray-regent font-size-14">{PaymentMethod}</span>
						</p>
					</div>
				),
			],
		},
	},
	{
		cell : {
			formatters : [
				(value, { rowData : { TransactionId } }) => (
					<div
						className="cursor-pointer"
						onClick={() => viewDetailsFunction(TransactionId)}
						onKeyPress={null}
						role="link"
						tabIndex={0}
					>
						<span className="font-regular padding-right-10 text-primary font-size-14">View Details</span>
						<span className="rkfm rkfm-share text-primary font-size-14" />
					</div>
				),
			],
		},
	},
]);

const officerOverviewJobColumns = (timeZoneId) => {
	const columnArray = [
		{
			property : 'JobEventId',
			header   : {
				label : 'Job #',
			},
			cell : {
				formatters : [
					(value) => (
						<div className="text-center">
							<a
								className="font-regular text-primary font-size-14"
								href={`jobs/${value}`}
							>
								{ value }
							</a>
						</div>
					),
				],
			},
		},
		{
			property : 'StartDateTime',
			header   : {
				label : 'Date',
			},
			cell : {
				formatters : [
					(value, { rowData : { ClockIn, ClockOut } }) => (
						<p className="margin-bottom-0 margin-left--10">
							<span className="font-regular display-block color-gray-oxford font-size-14">
								{ utils.parseUTCDateToTimeZone(value, timeZoneId).format('M/D/YYYY') }
							</span>
							<Choose>
								<When condition={ClockIn && ClockOut}>
									<span className="font-regular display-block color-gray-bayoux font-size-12">
										{ utils.parseUTCDateToTimeZone(ClockIn, timeZoneId).format('h:mm A') }
										{' '}
										-
										{' '}
										{ utils.parseUTCDateToTimeZone(ClockOut, timeZoneId).format('h:mm A') }
									</span>
								</When>
								<Otherwise>
									<span className="font-regular display-block color-gray-bayoux font-size-12">No Clock In</span>
								</Otherwise>
							</Choose>
						</p>
					),
				],
			},
		},
		{
			property : 'StartDateTime',
			header   : {
				label : 'Start Time',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="margin-left-10 font-regular color-blue-cloud-burst font-size-14">
							{ utils.parseUTCDateToTimeZone(value, timeZoneId).format('h:mm A') }
						</span>
					),
				],
			},
		},
		{
			property : 'Client',
			header   : {
				label : 'Client',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'Project',
			header   : {
				label : 'Project Name',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'JobEventName',
			header   : {
				label : 'Job Title',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'JobLocation',
			header   : {
				label : 'Job Location',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'OfficerRank',
			header   : {
				label : 'Rank',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'OfficerName',
			header   : {
				label : 'Officer',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'HoursScheduled',
			header   : {
				label : 'Hours Scheduled',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'HoursWorked',
			header   : {
				label : 'Hours Worked',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'Alerts',
			header   : {
				label : 'Alerts',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
	];
	return columnArray;
};

const officerOverviewLocationColumns = () => {
	const columnArray = [
		{
			property : 'Client',
			header   : {
				label : 'Client',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'Project',
			header   : {
				label : 'Project Name',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'JobLocation',
			header   : {
				label : 'Job Location',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'JobLocationAddress',
			header   : {
				label : 'Location Address',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'JobsScheduled',
			header   : {
				label : 'Job Scheduled',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'HoursScheduled',
			header   : {
				label : 'Hours Scheduled',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
		{
			property : 'HoursWorked',
			header   : {
				label : 'Hours Worked',
			},
			cell : {
				formatters : [
					(value) => (
						<span className="font-regular display-block color-gray-oxford font-size-14">{ value }</span>
					),
				],
			},
		},
	];
	return columnArray;
};

export {
	reportsColumn,
	officersColumns,
	projectsColumns,
	reportsJobColumn,
	paymentReportsColumn,
	clientOverviewColumns,
	officerOverviewJobColumns,
	officerOverviewLocationColumns,
	transactionHistoryColumn,
};
